import { type LoaderFunctionArgs, redirect } from "react-router";
import { BASE_PATH } from "src/basepath";
import { getToken } from "src/business-hooks/useToken";
import { tenantImpersonationLoader } from "./tenantImpersonationLoader";

export const authRouterLoader = async (
  args: LoaderFunctionArgs
): Promise<Response | null> => {
  if (getToken()) {
    // User is authenticated, check for tenant impersonation
    const impersonationResult = await tenantImpersonationLoader(args);
    if (impersonationResult) {
      return impersonationResult;
    }
    return null;
  }

  const url = new URL(args.request.url);
  if (/\/login\/?$/.test(url.pathname)) {
    return null;
  }
  const baseSuffix = BASE_PATH.replace(/\/$/, "");
  const strippedPathname = baseSuffix
    ? url.pathname.replace(baseSuffix, "")
    : url.pathname;
  // React Router's Request.url never includes hash fragments, so read from window.location directly
  const hash = typeof window !== "undefined" ? window.location.hash : "";
  let pathOnly = strippedPathname.replace(/^\//, "") + url.search + hash; // remove leading "/"

  if (pathOnly.includes("logout")) {
    pathOnly = "";
  }

  const encodedPath = encodeURIComponent(pathOnly);

  return redirect("/login" + (pathOnly ? `?redirect=${encodedPath}` : ""));
};
